import type { JSX } from "react";
import type { ActiveTimer } from "./useRecipeTimers";
import { formatTimerDuration } from "./timer-display";
import { remainingSeconds } from "./useRecipeTimers";

type TimerBarProps = {
  timers: readonly ActiveTimer[];
  nowMs: number;
  flash?: boolean;
  onSnooze: (timerId: string) => void;
  onCancel: (timerId: string) => void;
};

export function TimerBar({ timers, nowMs, flash = false, onSnooze, onCancel }: TimerBarProps): JSX.Element | null {
  if (timers.length === 0) {
    return null;
  }

  return (
    <div className={`cook-timer-bar${flash ? " cook-timer-bar-flash" : ""}`}>
      {timers.map((timer) => {
        const remaining = remainingSeconds(timer, nowMs);
        const progress = timer.durationSeconds > 0 ? remaining / timer.durationSeconds : 0;
        const urgent = remaining > 0 && remaining <= 60;
        return (
          <div key={timer.id} className={`cook-timer-item${urgent ? " cook-timer-urgent" : ""}`}>
            <div className="cook-timer-meta">
              <span>{timer.label}</span>
              <span>{formatTimerDuration(remaining)}</span>
            </div>
            <div className="cook-timer-progress" style={{ transform: `scaleX(${String(progress)})` }} />
            <div className="cook-timer-actions">
              <button type="button" className="text-button" onClick={() => { onSnooze(timer.id); }}>
                Snooze
              </button>
              <button type="button" className="text-button" onClick={() => { onCancel(timer.id); }}>
                Cancel
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
